
import React from 'react';
import { useDispatch } from 'react-redux';
import { IoMdTime } from 'react-icons/io';
import { FaRegCheckCircle } from 'react-icons/fa';
// import TabComponent from '../TabComponent';

import TabComponent from '../../../../Components/TabComponent/TabComponent';
import PurchaseApprovalApproved from './ReferralsShemeApproved';
import PurchaseApprovalPending from './ReferralsShemePendingApproval';
import { setHeaderName, setSubHeaderName } from '../../../../ReduxStore/Slices/headerSlice';
import { IoMdCloseCircleOutline } from "react-icons/io";
import SchemeApprovalPending from './ReferralsShemePendingApproval';
import SchemeApprovalApproved from './ReferralsShemeApproved';
import SchemeApprovalReject from './ReferralsShemeRejectApproval';
import ReferralsShemeApproved from './ReferralsShemeApproved';
import ReferralsShemePendingApproval from './ReferralsShemePendingApproval';
import ReferralsShemeRejectApproval from './ReferralsShemeRejectApproval';

// import { IoMdTime } from "react-icons/io";

const ReferralsSchemeApprovalTabs = () => {
    const dispatch = useDispatch();

 
     React.useEffect(() => {
         dispatch(setHeaderName("Scheme Approval"));
         dispatch(setSubHeaderName("Referral Scheme"));
 
     }, [dispatch]);
    const tabsHeadData = [
        { label: 'Pending', icon: <IoMdTime /> },
        { label: 'Approved', icon: <FaRegCheckCircle /> },
        { label: 'Reject', icon: <IoMdCloseCircleOutline /> },
        
    ];

    const tabsComponent = [
        <ReferralsShemePendingApproval/>,
        <ReferralsShemeApproved />,   
        <ReferralsShemeRejectApproval />
        
    ];

    return (
        <div>
            <TabComponent tabsData={tabsHeadData} tabComponents={tabsComponent} />
        </div>
    );
};

export default ReferralsSchemeApprovalTabs;
